import { get } from '@/utils/axios/serverConfig'

export interface ProductSlugDetails {
  slug: string
  redirect_url: string
  entity_type: string
  entity_id: number
  metadata: Record<string, unknown>
}

const getProductDetailsFromSlug = async (
  slug: string,
  entityType = 'PRODUCT',
) => {
  return await get<ProductSlugDetails[]>(
    `slug/v1/resolve-slug?identifiers=${slug}&entity_type=${entityType}`,
  )
}

export default getProductDetailsFromSlug
